<template>
  <div class="operate_box">
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" @click="onCommentClick" v-if="allowComment"></van-button>
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" disabled v-else></van-button>
    <div class="operate_right">
      <span class="comment" @click="viewComments($event)" v-if="allowComment != false && allowComment != 0">
        <Icon iconClass="comment" />
      </span>
      <span class="praise" v-if="allowLike != false && allowLike != 0">
        <Icon iconClass="praise" @click="cancelPraiseHandler" v-if="isLiked == true" />
        <Icon iconClass="praise-o" @click="praiseHandler" v-else />
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import commApi from "@/api/apis/common.js";
export default {
  name: "Operate",
  props: {
    params: {
      type: Object,
      default: null,
    },
    id: {
      type: Number,
      default: "",
    },
    allow: {
      type: Boolean,
      default: false,
    },
    allowLikes: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId"]),
  },
  data() {
    return {
      allowComment: false,
      allowLike: true,
      isLiked: false, // 是否已点赞
    };
  },
  watch: {
    allow: {
      handler(newValue, oldValue) {
        this.allowComment = newValue;
      },
      deep: true,
    },
    allowLikes: {
      handler(newValue, oldValue) {
        this.allowLike = newValue;
      },
      deep: true,
    }
  },
  methods: {
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            if (res.data.userLikes == 1) {
              _this.isLiked = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 显示评论表单 */
    onCommentClick() {
      if (this.allowComment) {
        if (!!this.userInfo) {
          this.$emit("showCommentForm", true);
        } else {
          this.$router.push("/login");
        }
      }
    },
    /* 显示所有评论 */
    viewComments(event) {
      this.$emit("showComments", true);
    },
    /* 点赞 */
    praiseHandler() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .giveThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = true;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消点赞 */
    cancelPraiseHandler() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      commApi
        .cancelThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    this.allowComment = this.allow;
    this.getThumbsUpStatus(); //获取点赞状态
  },
};
</script>
<style scoped lang="scss">
.operate_box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 40px;
  padding: 5px 15px;
  background-color: #fff;
  border-top: 1px solid #ebedf0;
  .comment_btn {
    width: 100%;
    height: 30px;
    background: #ebedf0;
    border: none;
    font-size: 14px;
    color: #b3b3b3;
    .van-button__content {
      padding-left: 10px;
      padding-right: 10px;
      -webkit-justify-content: normal;
      justify-content: normal;
      text-align: left;
    }
  }
  .operate_right {
    flex: none;
    // width: 62px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    text-align: right;
    .comment {
      margin-left: 10px;
    }
    .praise {
      margin-left: 10px;
    }
    .tj-svg-icon {
      color: #bebebe;
      vertical-align: middle;
      &.tj-icon-comment {
        font-size: 18px;
      }
      &.tj-icon-praise-o {
        font-size: 20px;
      }
      &.tj-icon-praise {
        font-size: 20px;
        color: #318bff;
      }
    }
    
  }
}
</style>